import React from "react";
import studentImage from "../assets/popupimages/student.jpg";
import parentImage from "../assets/popupimages/parent.jpg";
import tutorImage from "../assets/popupimages/tutor.jpg";
import swotbuddyImage from "../assets/popupimages//community_new.svg";
import rightArrow from "../assets/right-arrow.svg";
import { useInView, animated, useTrail } from "@react-spring/web";
import nextArrow from '../assets/next.svg'; 

const PartThree = ({ showPopup }) => {
  const [refV, boxSprings] = useInView(
    () => ({
      from: { opacity: 0 },
      to: { opacity: 1 },
    }),
    { root: null, rootMargin: "-20px", threshold: 0.3, once: true }
  );

  const [childContainerRef, childContainerInView] = useInView({
    root: null,
    rootMargin: "-20px",
    threshold: 0.3,
    once: true,
  });

  const textContent = [
    {
      title: "AI Study <br> Tools",
      image: studentImage,
      text: "Access a powerful suite of AI-powered study tools designed to transform your learning experience. These include interactive quizzes that adjust to your progress, virtual labs for hands-on experimentation, dynamic mind mapping tools for organizing ideas, coding challenges to sharpen your programming skills, and many more innovative features. Each tool is designed to help you delve deeper into subjects at your own pace.",
      button: "start to learn",
    },
    {
      title: "Unique Matrix <br> Test",
      image: parentImage,
      text: "Discover your personalized learning style through our unique matrix test. This interactive assessment evaluates your study habits and preferences to provide customized recommendations for tools and resources. Additionally, you'll receive a curated news feed featuring the latest educational trends and insights tailored to your interests, ensuring that you always have the most relevant content at your fingertips.",
    },
    {
      title: "LLM-Powered<br>  Assistance",
      image: tutorImage,
      text: "Enhance your study sessions with advanced language learning models (LLMs) that offer real-time support, answer your questions, and provide clarifications on complex topics. This intelligent assistance helps you grasp challenging concepts quickly and effectively, serving as your on-demand study partner.",
    },
    {
      title: "Community & <br> Collaboration",
      image: swotbuddyImage,
      text: "Join a vibrant internal community where you can connect with peers who share your passion for learning. Engage in study groups, participate in lively forum discussions, and collaborate in real-time through built-in conferencing and messaging tools. This collaborative space is designed to foster idea exchange, provide mutual support, and help you build valuable connections on your academic journey.",
    },
  ];

  const trails = useTrail(textContent.length, {
    config: { duration: 200 },
    from: { y: 30, opacity: 0 },
    to: { y: 0, opacity: 1 },
    // Remove conditional rendering and unnecessary delay
    delay: (index) => index * 100, // Stagger effect with fixed delay
  });

  const openPopup = (content) => {
    showPopup({
      image: content.image,
      text: content.text,
      hasButton: content.button ? true : false,
    });
    console.log("showPopup triggered in PartThree");
  };

  return (
    <React.Fragment>
      <animated.div
        id={"explore_learning"}
        className="mt-20 mb-40 "
        ref={refV}
        style={boxSprings}
      >
        <p className="text-3xl text-gray-600 mb-14 text-center">
          Student Tools
        </p>
        <div
          ref={childContainerRef}
          key={"child-container"}
          className="flex justify-center align-center gap-8 lg:gap-12 flex-wrap"
        >
          {trails.map((styles, index) => (
            <animated.div
              key={index}
              className="flex flex-col justify-between items-start text-white bg-[#686466] rounded-xl p-6 h-[220px] w-[280px] shadow-md"
              style={styles}
            >
              <h3 className="rounded-2xl bg-[#585556] text-white text-xl text-center w-10/12 px-2 py-5"
                dangerouslySetInnerHTML={{ __html: textContent[index].title }} />
              <button
                className="rounded-xl bg-[#B1E1E9] shadow-xl place-items-center w-10 h-10 p-3 mt-2"
                onClick={() => openPopup(textContent[index])}
              >
                <img
                  className="text-white" // commenting out this bg-[#B1E1E9] color as it is not required here
                  // src={rightArrow}
                  src={nextArrow}
                  alt="right_arrow_icon"
                />
              </button>
            </animated.div>
          ))}
        </div>
      </animated.div>
    </React.Fragment>
  );
};

export default PartThree;